import api from './api';

const contractTypeMasterService = {
  // Get all contract types
  getAllContractTypes: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      if (params.status) queryParams.append('status', params.status);
      if (params.category) queryParams.append('category', params.category);
      if (params.search) queryParams.append('search', params.search);

      const queryString = queryParams.toString();
      const url = `/contract-type-master${queryString ? `?${queryString}` : ''}`;
      
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching contract types:', error);
      throw error;
    }
  },

  // Get contract type by ID
  getContractTypeById: async (id) => {
    try {
      const response = await api.get(`/contract-type-master/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching contract type:', error);
      throw error;
    }
  },

  // Get next contract type code
  getNextContractTypeCode: async () => {
    try {
      const response = await api.get('/contract-type-master/code/next');
      return response.data;
    } catch (error) {
      console.error('Error fetching next contract type code:', error);
      throw error;
    }
  },

  // Create contract type
  createContractType: async (contractTypeData) => {
    try {
      const response = await api.post('/contract-type-master', contractTypeData);
      return response.data;
    } catch (error) {
      console.error('Error creating contract type:', error);
      throw error;
    }
  },

  // Update contract type
  updateContractType: async (id, contractTypeData) => {
    try {
      const response = await api.put(`/contract-type-master/${id}`, contractTypeData);
      return response.data;
    } catch (error) {
      console.error('Error updating contract type:', error);
      throw error;
    }
  },

  // Delete contract type
  deleteContractType: async (id) => {
    try {
      const response = await api.delete(`/contract-type-master/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting contract type:', error);
      throw error;
    }
  },

  // Get contract type statistics
  getContractTypeStats: async () => {
    try {
      const response = await api.get('/contract-type-master/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching contract type statistics:', error);
      throw error;
    }
  }
};

export default contractTypeMasterService;

